import { render, staticRenderFns } from "./AGestiones.vue?vue&type=template&id=36a9814c"
import script from "./AGestiones.vue?vue&type=script&lang=js"
export * from "./AGestiones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports